import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addCompanyUserTodo = createAsyncThunk('addCompanyUser', async (data) => {


    try {
        const res = await axios({

            method: 'POST',
            url: getConfig.API_URL + 'create_user',
            data: {
                "company_id": data?.values?.company_id,
                "first_name": data?.values?.first_name,
                "last_name": data?.values?.last_name,
                "email": data?.values?.email,
                "phone": data?.values?.phone,
                "password": data?.values?.password,
                "role_id": 2,
                // "status": data?.values?.status
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
